export function sortDescBy<T extends Record<string, any>>(
  arr: Array<T>,
  key: keyof T
): Array<T> {
  return arr.sort(function (a, b) {
    return b[key] - a[key];
  });
}
